import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import * as Sentry from "@sentry/angular";
import { environment } from './environments/environment';
import { BUILD_ID } from './environments/build-id';
import { registerLocaleData } from '@angular/common';
import localeDE from '@angular/common/locales/de';

// Register German locale data
registerLocaleData(localeDE, 'de-DE');

if (environment.env !== 'local') {
  Sentry.init({
    dsn: "https://76ad5561341a85ae042456535033a5ec@sentry.silberfluss.io/7",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        blockAllMedia: true,
        maskAllText: true,
        maskAllInputs: true
      }),
      Sentry.captureConsoleIntegration({
        levels: ['log', 'warn', 'error']
      })
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: ["localhost", new RegExp(environment.apiUrl)],
    replaysSessionSampleRate: environment.env === 'staging' ? 1.0 : 0.05,
    replaysOnErrorSampleRate: environment.env === 'staging' ? 1.0 : environment.env === 'production' ? 0.5 : 0.1,
    environment: environment.env,
    release: BUILD_ID,
  })
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
